// global imports
import React, { useEffect } from 'react';
import { withLocalize } from 'react-localize-redux';
import { useDispatch, useSelector } from 'react-redux';

// project imports
import { getSettingsRequest } from '../../../../store/actions/common_actions';

// local imports
import Label from '../../../../components/NewUI/Label/Label';
import SettingsContainer from '../../../../components/NewUI/SettingsContainer';
import { config } from '../../../../config';
import { IState } from '../../../../store/reducers';
import DestinationSystem from '../../CommonWidgets/DestinationSystem/DestinationSystem';
import BexioConfig from '../PrestashopApp/components/BexioConfig/BexioConfig';
import WeclappConfig from '../PrestashopApp/components/WeclappConfig/WeclappConfig';
import AuthCreds from './components/AuthCreds/AuthCreds';
import { Props, StateProps } from './types';

const ForceManagerApp = (props: Props) => {
  const dispatch = useDispatch();
  const forcemanagerSettings = useSelector<IState, StateProps['forcemanagerSettings']>(
    ({ forcemanager: { settings } }) => settings,
  );

  useEffect(() => {
    dispatch(getSettingsRequest({ system: 'forcemanager' }));
  }, []);

  const getDestinationSystemSettings = () => {
    if (config.activeDomain === 'bexio' || forcemanagerSettings.destinationSystem === 'bexio') {
      return <BexioConfig system="ForceManager" />;
    }

    switch (forcemanagerSettings.destinationSystem) {
      case 'zoho-books':
        return <Label title="Zoho Books" desc="Coming soon" />;
      case 'weclapp':
        return <WeclappConfig />;
      default:
        return <BexioConfig system="ForceManager" />;
    }
  };

  return (
    <SettingsContainer appName="ForceManager">
      <AuthCreds />
      {config.activeDomain !== 'bexio' && <DestinationSystem system="forcemanager" />}
      {getDestinationSystemSettings()}
    </SettingsContainer>
  );
};

export default withLocalize(ForceManagerApp);
